/**
 * Created by mly on 2017/12/19.
 */
const util = {
    tax_base_blind_area_2018: [18000.0, 19283.33, 54000.0, 60187.5, 108000.0, 114600, 420000.0, 447500, 660000.0, 706538.46, 960000.0, 1120000],
    calcBonusTax20180222(bonus) {
        const avg_bonus = Math.max(1, bonus / 12);
        let tax = 0;
        if (avg_bonus < 1500) {
            tax = bonus * 0.03;
        } else if (avg_bonus < 4500) {
            tax = bonus * 0.1 - 105;
        } else if (avg_bonus < 9000) {
            tax = bonus * 0.2 - 555;
        } else if (avg_bonus < 35000) {
            tax = bonus * 0.25 - 1005;
        } else if (avg_bonus < 55000) {
            tax = bonus * 0.3 - 2755;
        } else if (avg_bonus < 80000) {
            tax = bonus * 0.35 - 5505;
        } else {
            tax = bonus * 0.45 - 13505;
        }
        return tax.toFixed(2);
    },
    calcTaxBaseByNetOptionPrice20180222(net_price, annual_bonus, bonus_tax) {
        const tmp_price = net_price * 1 + annual_bonus * 1 - bonus_tax * 1;
        const tax_deduct = util.lookup(tmp_price, [17459, 48704, 86954, 316004, 464754, 629504], [0, 105, 555, 1005, 2755, 5505, 13505]);
        const tax_rate = util.lookup(tmp_price, [17459, 48704, 86954, 316004, 464754, 629504], [0.03, 0.1, 0.2, 0.25, 0.3, 0.35, 0.45]);
        const tax_base = (tmp_price - tax_deduct) / (1 - tax_rate);
        return tax_base.toFixed(2);
    },
    tax_base_blind_area_2019: [36000.00, 38566.67, 144000.0, 160500, 300000.0, 318333.33, 420000.0, 447500, 660000.0, 706538.46, 960000.0, 1120000],
    calcBonusTax20190213(bonus) {
        const avg_bonus = Math.max(1, bonus / 12);
        let tax = 0;
        // <= 临界点不进位
        if (avg_bonus <= 3000) {
            tax = bonus * 0.03;
        } else if (avg_bonus <= 12000) {
            tax = bonus * 0.1 - 210;
        } else if (avg_bonus <= 25000) {
            tax = bonus * 0.2 - 1410;
        } else if (avg_bonus <= 35000) {
            tax = bonus * 0.25 - 2660;
        } else if (avg_bonus <= 55000) {
            tax = bonus * 0.3 - 4410;
        } else if (avg_bonus <= 80000) {
            tax = bonus * 0.35 - 7160;
        } else {
            tax = bonus * 0.45 - 15160;
        }
        return tax.toFixed(2);
    },
    calcTaxBaseByNetOptionPrice20190213(net_price, annual_bonus, bonus_tax) {
        const tmp_price = net_price * 1 + annual_bonus * 1 - bonus_tax * 1;
        const tax_deduct = util.lookup(tmp_price, [34920, 129810, 241410, 317660, 466410, 631160], [0, 210, 1410, 2660, 4410, 7160, 15160]);
        const tax_rate = util.lookup(tmp_price, [34920, 129810, 241410, 317660, 466410, 631160], [0.03, 0.1, 0.2, 0.25, 0.3, 0.35, 0.45]);
        const tax_base = (tmp_price - tax_deduct) / (1 - tax_rate);
        return tax_base.toFixed(2);
    },
    lookup(value, value_arr, result_arr) {
        const len = value_arr.length;
        const r_len = result_arr.length;
        if (r_len - len !== 1) {
            throw ('value_arr 的长度应为 result_arr 的长度减一');
        }
        let ret = undefined;
        for (let i = 0; i < len; i++) {
            if (value < value_arr[i]) {
                ret = result_arr[i];
                break;
            }
        }
        if (ret === undefined) {
            ret = result_arr[r_len - 1];
        }
        return ret;
    }
};

// 返回所有的key值
export function isDiff({source, target, _key = '' } = {}, bad_val = [undefined, null, '']) {
    if (bad_val.includes(source) && bad_val.includes(target)) {
        return 
    }
    if (bad_val.includes(source) || bad_val.includes(target)) {
        console.log(_key)
        return true
    }
    switch (Object.prototype.toString.apply(target)) {
        case '[object Object]':
                if (Object.prototype.toString.apply(source) !== '[object Object]') {
                    console.log(_key)
                    return true
                }
             return Object.keys(target).some((key) => {
                 if (!source) {
                    console.log(_key)
                     return true
                 }
                 return isDiff({
                    source: source[key],
                    target: target[key],
                    _key:`${_key}/${key}`
                 }, bad_val)
             })
        case '[object Array]':
            if (Object.prototype.toString.apply(source) !== '[object Array]') {
                console.log(_key)
                return true
            }
            return target.some((item, index) => {
                return isDiff({
                    target: target[index],
                    source: source[index],
                    _key:`${_key}/${index}`
                }, bad_val)
            })
        case '[object Number]':
            return target !== Number(source) && console.log(_key)
        case '[object String]':
            return target !== source + '' && console.log(_key)
        default:
            return target !== source && console.log(_key)
    }
}

export default util;